import { useHistory } from 'react-router-dom';

export function useCustomHistory<T>() {
	const history = useHistory<T>();
	return {
		refreshPage: () => history.go(0),
		history,
	};
}
